import { Routes, Route } from 'react-router-dom';
import Layout from './app/Layout';
import Login from './app/login/page';
import PersistLogin from './app/persist-login/page';
import { setDefaultOptions } from "date-fns";
import { nl, fr, enUS } from "date-fns/locale";
import Portal from './app/portal/page';
import DashboardPage from './app/startpage/page';
import { useEffect, useState } from 'react';
import Intervention from './app/intervention/page';
import CreateCall from './app/create-call/page';
import Settings from './app/settings/page';
import MoreInfo from './app/more-info/page';
import { useTranslation } from 'react-i18next';
import Calendar from './app/calendar/page';
import ForgotPassword from './app/forgot-password/page';
import ResetPassword from './app/reset-password/page';
import RegisterPage from './app/register/page';
import { useLanguage } from './context/LanguageProvider';
import Stock from './app/stock/page';
import { useVersionCheck } from './hooks/use-version-check';
import { UpdateDialog } from './app/version-update-dialog';
import HomeRide from './app/home-ride/page';

function App() {
  const { i18n } = useTranslation()
  const { setLanguage } = useLanguage();

  useEffect(() => {
    setLanguage(i18n.language as any);

    switch (i18n.language) {
      case 'nl':
        setDefaultOptions({ locale: nl })
        break;
      case 'fr':
        setDefaultOptions({ locale: fr })
        break;
      case 'en':
        setDefaultOptions({ locale: enUS })
        break;
      default:
        setDefaultOptions({ locale: enUS })
        break;
    }
  }, [i18n.language])

  const hasUpdate = useVersionCheck();
  const [showDialog, setShowDialog] = useState(false);

  useEffect(() => {
    if (hasUpdate) setShowDialog(true);
  }, [hasUpdate]);

  useEffect(() => {
    const listener = () => setShowDialog(true);
    window.addEventListener('update-available', listener);
    return () => window.removeEventListener('update-available', listener);
  }, []);

  return (
    <>
      <Routes>
        <Route path="/*" element={<Layout />}>
          <Route path="login" element={<Login />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="reset-password" element={<ResetPassword />} />
          <Route path="register" element={<RegisterPage />} />

          <Route element={<PersistLogin />}>
            <Route element={<Portal />}>
              {/* {['','startpagina/*'].map((p,i)=>(
              <Route path={p} element={<DashboardPage />} key={i}/>
            ))} */}

              <Route index element={<DashboardPage />} />
              <Route path="startpagina/*" element={<DashboardPage />} />

              <Route path="intervention/*" element={<Intervention />} />

              <Route path="oproep-aanmaken/*" element={<CreateCall />} />

              <Route path="kalender/*" element={<Calendar />} />

              <Route path="stock/*" element={<Stock />} />

              <Route path="instellingen/*" element={<Settings />} />

              <Route path="meer-info/*" element={<MoreInfo />} />

              <Route path="thuisrit/*" element={<HomeRide />} />

            </Route>
          </Route>

          {/* <Route path="/*" element={<p>Pagina niet gevonden</p>}/> */}
          <Route path="*" element={<p>Pagina niet gevonden</p>} />
        </Route>
      </Routes>

      <UpdateDialog
        open={showDialog}
        onConfirm={() => {
          setShowDialog(false);
          window.location.reload();
        }}
      />
    </>
  );
}

export default App;
